import React from 'react';
import classNames from 'clsx';
import { useSelector } from 'react-redux';

import { FormSectionMessageProps } from './FormSectionMessage.interfaces';
import { useStyles } from './FormSectionMessage.styles';
import { customFormSectionMessage } from './customFormSectionMessage';
import { Alert } from 'app/components/Alert';
import { MessagesEnum } from 'app/shared/enums';
import { selectIsPaymentMethodOnInstallmentsActive } from 'app/store/data/quotationResult';

const bonusMessageKeys = [
  MessagesEnum.PaymentPromotionCodeMessage,
  MessagesEnum.PaymentPromotionCodeMessageInternalTransfer,
];

export default function FormSectionMessage({
  message,
}: FormSectionMessageProps) {
  const classes = useStyles();
  const isPaymentMethodOnInstallmentsActive = useSelector(
    selectIsPaymentMethodOnInstallmentsActive
  );

  const Component = customFormSectionMessage[message.key] || Alert;
  const isBonusMessageInPaymentMethodTest =
    isPaymentMethodOnInstallmentsActive &&
    bonusMessageKeys.includes(message.key as MessagesEnum);

  return message.visible ? (
    <div
      className={classNames(classes.root, {
        [classes.rootSectionWidth]: isBonusMessageInPaymentMethodTest,
      })}
    >
      <Component
        text={message.htmlContent || message.content}
        type={message.type}
        className={classNames(classes.message, {
          [classes.messageRounded]: isBonusMessageInPaymentMethodTest,
        })}
        icon={message.htmlContent ? false : undefined}
      />
    </div>
  ) : null;
}
